export var AnswerType;
(function (AnswerType) {
    AnswerType[AnswerType["TextObject"] = 0] = "TextObject";
    AnswerType[AnswerType["TableObject"] = 1] = "TableObject";
})(AnswerType || (AnswerType = {}));
